import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';

const ColorName = ({ form, disabled, colorsTypes }) => {
  const { getFieldDecorator } = form;
  const handleChange = val => {
    if (val && form.getFieldError('color')) {
      form.setFieldsValue({ color: val });
    }
  };
  return (
    <Fragment>
      <span className="label">Цвет:</span>
      <Form.Item>
        {getFieldDecorator('color')(
          <Select
            placeholder="Выберите цвет"
            className="basicInput"
            disabled={disabled}
            onChange={handleChange}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {colorsTypes &&
              colorsTypes.map((color, index) => (
                <Select.Option value={color.vehicleColorId} key={index}>
                  {color.colorName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(ColorName, ['colorsTypes']);
